module.exports = __webpack_public_path__ + "img/MT4.6f783eca.png";